import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { isMobileSelector } from '../selector/device';
import { mobileChannelListSelector } from '../selector/channel';
import setWrappedComponent from '../utils/react/setWrappedComponent';
import useTabCentered from '../hooks/useTabCentered';
import appendQueryString from '../utils/appendQueryString';
import { TRACKING_PAGEVIEW_SOURCE } from '../../constants/tracking';

/**
 *  @note  tab「推薦」會導至首頁，因需要讓首頁 reload 才能取得所需資料，且為讓資料單純，因此不另跟分館 API 資料重組，並以 <a> 作連結
 */
export default function renderChannelListNav(WrappedComponent) {
  function RenderChannelListNav(props) {
    const isMobile = useSelector(isMobileSelector);
    const channels = useSelector(mobileChannelListSelector);

    const { pathname } = useLocation();

    const currentLinkTab = useRef(null);
    useTabCentered([pathname], currentLinkTab);

    if (!isMobile) {
      return <WrappedComponent {...props} />;
    }

    return (
      <>
        <div className="sticky z-20" style={{ top: 'var(--navbar-height)' }}>
          <nav className="TabList">
            <NavLink
              to="/"
              ref={pathname === '/' ? currentLinkTab : null}
              className="TabList-tab"
              activeClassName="is-active"
              exact
            >
              推薦
            </NavLink>
            {channels?.map((channel) => (
              <NavLink
                key={channel.id}
                to={appendQueryString(`/channel/${channel.id}`, {
                  source: TRACKING_PAGEVIEW_SOURCE.CHANNEL_LIST_TAB,
                  feed_id: channel.feedId,
                  channel_id: channel.id,
                })}
                ref={pathname === `/channel/${channel.id}` ? currentLinkTab : null}
                className="TabList-tab"
                activeClassName="is-active"
                exact
              >
                {channel.name}
              </NavLink>
            ))}
          </nav>
        </div>
        <WrappedComponent {...props} />
      </>
    );
  }

  setWrappedComponent(RenderChannelListNav, WrappedComponent);

  return RenderChannelListNav;
}
